import * as api from '../api';

export class CoachPlaceModel {
    number: string;
    gender: 'None';
    placeType: 'Lower';
    fare: {
        amount: number;
        currency: string;
    };
    selected = false;

    constructor(coachPlace: api.CoachPlace) {
        this.number = String(coachPlace.number);
        this.gender = coachPlace.gender;
        this.placeType = coachPlace.placeType;
        this.fare = coachPlace.fare;
    }
}

export class CoachModel {
    schemaId: string | null;
    number: string;
    type: string;
    isTwoStorey: boolean;
    isCanChooseBedding: boolean;
    hasDynamicPricing: boolean;
    isPetsAllowed: boolean;
    isPetInCoachAllowed: boolean;
    electronicTicket: boolean;
    isBranded: boolean;
    beddingTariff: null;
    loyaltyCards: string[] = [];
    fareInfo: null;
    places: CoachPlaceModel[] = [];
    placesInfo: {
        lowerSide: null;
        upperSide: null;
        upperCoupe: number;
        lowerCoupe: number;
        total: null;
    };
    serviceClass: {
        code: string;
        name: string;
        description: string;
    };
    selectedPlacesQueue: CoachPlaceModel[] = [];

    constructor(coach: api.Coach) {
        this.schemaId = coach.schemaId;
        this.number = coach.number;
        this.type = coach.type;
        this.isTwoStorey = coach.isTwoStorey;
        this.isCanChooseBedding = coach.isCanChooseBedding;
        this.hasDynamicPricing = coach.hasDynamicPricing;
        this.isPetsAllowed = coach.isPetsAllowed;
        this.isPetInCoachAllowed = coach.isPetInCoachAllowed;
        this.electronicTicket = coach.electronicTicket;
        this.isBranded = coach.isBranded;
        this.beddingTariff = coach.beddingTariff;
        coach.loyaltyCards?.forEach((loyaltyCard) => {
            this.loyaltyCards.push(loyaltyCard);
        });
        this.fareInfo = coach.fareInfo;
        coach.places.forEach((coachPlace) => {
            this.places.push(new CoachPlaceModel(coachPlace));
        });
        this.placesInfo = coach.placesInfo;
        this.serviceClass = coach.serviceClass;
    }

    get selectedPlacesCount() {
        const selectedPlacesCount = this.places.filter(place => place.selected).length;

        if (selectedPlacesCount) {
            return selectedPlacesCount;
        }

        return 0;
    }
}

export class TrainModel {
    number: string;
    name: string | null;
    provider: string;
    isSuburban: boolean;
    direction: 'Outward' | 'Return' | 'Both';
    coaches: CoachModel[] = [];
    selectedCoach: CoachModel;

    constructor(train: api.Train) {
        this.number = train.number;
        this.name = train.name;
        this.provider = train.provider;
        this.isSuburban = train.isSuburban;
        this.direction = train.direction;
        train.coaches.forEach((coach) => {
            this.coaches.push(new CoachModel(coach));
        });
        if (this.coaches.length) {
            this.selectedCoach = this.coaches[0];
        }
    }

    get selectedPlaces() {
        let trainPlaces: api.TrainPlace[] = [];

        this.selectedCoach.selectedPlacesQueue.forEach((place) => {
            trainPlaces.push({
                train: this.number,
                coach: this.selectedCoach.number,
                place: place.number,
                placeType: place.placeType,
                gender: place.gender
            });
        });

        return trainPlaces;
    }
}
